/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function() {
      const productsToHide = document.querySelectorAll('[data-hide="true"]');

      productsToHide.forEach(product => {
        product.style.display = 'none';
      });
    });

  const closePopup = document.getElementById('closePreorderPopup');
  const popup = document.getElementById('preorderPopup');
  const addCartBtn = document.querySelector('#AddToCart--template--19408696836348__main');

  if (addCartBtn) {
    document.querySelector('#AddToCart--template--19408696836348__main').addEventListener('click', function() {
        const orderInput = document.querySelector('input[data-product-preorder]');
          
          if (orderInput.value == 'Pre-order')
          {
            popup.style.display = 'flex';
          }
    });
  }

  const quickButtons = document.querySelectorAll('quick-add-product');

  quickButtons.forEach(element => {
    element.addEventListener('click', function(event) {
        const orderText = event.currentTarget.querySelector('input[name="properties[Sale type]"]');

        if (orderText && orderText.value === 'Pre-order')
        {
          popup.style.display = 'flex';
        }
    });
  });

  closePopup.addEventListener('click', () => {
              popup.style.display = 'none';
          });

  window.addEventListener('click', (event) => {
      if (event.target === popup) {
        popup.style.display = 'none';
      }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
